import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { OrganizationContextService } from "./organization-context.service";
import {
  ConfirmOrgWriteDialogComponent,
  ConfirmOrgWriteDialogData,
} from "src/app/views/super-admin/components/confirm-org-write-dialog/confirm-org-write-dialog.component";

@Injectable({ providedIn: "root" })
export class OrgWriteGuardService {
  constructor(
    private orgContext: OrganizationContextService,
    private dialog: MatDialog
  ) {}

  /**
   * Returns an Observable<boolean> indicating whether the caller is allowed
   * to proceed with a settings write. Resolves to `true` immediately when
   * the active org is Qupil (no friction). Otherwise opens a modal naming
   * the feature and the active non-Qupil org, and resolves to the user's
   * choice.
   */
  confirmWrite(feature: string): Observable<boolean> {
    if (this.orgContext.isQupil) {
      return of(true);
    }

    const data: ConfirmOrgWriteDialogData = {
      feature,
      orgName: this.orgContext.getOrganizationName(this.orgContext.currentOrgId),
      orgId: this.orgContext.currentOrgId,
    };

    return this.dialog
      .open<ConfirmOrgWriteDialogComponent, ConfirmOrgWriteDialogData, boolean>(
        ConfirmOrgWriteDialogComponent,
        { data, width: "480px" }
      )
      .afterClosed()
      .pipe(map((result) => result === true));
  }
}
